import { z } from "zod";
export const DTOLiveblocksAuthRequest = z.object({
    room: z.string().optional(),
});
